export default __webpack_public_path__ + "static/media/1_0102.d90bea7a.webp";